import { useOktaAuth } from '@okta/okta-react';

export const useAuthToken = () => {
  const { authState } = useOktaAuth();
  return authState?.accessToken?.accessToken || undefined;
};
